module.exports = __webpack_public_path__ + "img/LogoSC.1cc4867a.png";